

import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Home from "./Components/Home";
import View from "./Components/View";
import Viewdet from "./Components/Viewdet";
import Landing from "./Components/Landing";
import Login from "./Components/Login";
import Signup from "./Components/Signup";
import Invoice from "./Components/Invoice";
import Profile from "./Components/Profile";
import Insulin from "./Components/Insulin";
import { UserProvider } from "./Components/context/UserContext";
import PrivateRoute from "./Components/PrivateRoute";
import { App as CapacitorApp } from '@capacitor/app';

function BackButtonHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const backListener = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      // If we aren't at the root (Login or Home), go back internally
      if (location.pathname !== '/' && location.pathname !== '/home') {
        navigate(-1);
      } else {
        // If we are at the "exit" points, close the app
        CapacitorApp.exitApp();
      }
    });

    return () => {
      backListener.then(l => l.remove());
    };
  }, [location, navigate]);

  return null; // This component doesn't render anything
}

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/login.html" element={<Login />} />
             {/* <Route path="/" element={<Login />} /> */}
          {/* <Route path="/login.html" element={<Navigate to="/" replace />} /> */}
          <Route path="/signup" element={<Signup /> } />
          <Route path="/landing" element={<PrivateRoute><Landing /></PrivateRoute>} />
          <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/view" element={<PrivateRoute><View /></PrivateRoute>} />
          <Route path="/viewdet" element={<PrivateRoute><Viewdet /></PrivateRoute>} />
          <Route path="/invoice" element={<PrivateRoute><Invoice /></PrivateRoute>} />
          <Route path="/insulin" element={<PrivateRoute><Insulin /></PrivateRoute>} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
